var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            "before-close": _vm.handleClose,
            direction: _vm.direction,
            "show-close": true,
            size: _vm.formData.width,
            title: _vm.formData.title,
            visible: _vm.drawer,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "invoice-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "el-row",
                { staticClass: "invoice-header" },
                [
                  _c("el-col", { staticClass: "invoice-left" }, [
                    _c("div", { staticClass: "invoice-logo" }, [
                      _c("i", { staticClass: "icon iconfont iconhetong" }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.drawer
                    ? _c("el-col", { staticClass: "invoice-right" }, [
                        _c("div", { staticClass: "txt1 over-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.dataInfo.customer_name) +
                              "\n            "
                          ),
                          _c("i", {
                            staticClass:
                              "el-icon-message-solid default-color pointer",
                            on: { click: _vm.addRecord },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "default-color pointer txt3",
                              on: { click: _vm.addRecord },
                            },
                            [_vm._v("添加提醒")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "txt2" }, [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("客户状态："),
                          ]),
                          _vm._v(" "),
                          _vm.dataInfo.customer_status == 0
                            ? _c("span", { staticClass: "info3" }, [
                                _vm._v("未成交"),
                              ])
                            : _c(
                                "span",
                                {
                                  class:
                                    _vm.dataInfo.customer_status == 1
                                      ? "info1"
                                      : "info2",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dataInfo.customer_status == 1
                                        ? "已成交"
                                        : "已流失"
                                    )
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$t("customer.salesman")) + "："),
                          ]),
                          _c("span", { staticClass: "weight" }, [
                            _vm._v(
                              _vm._s(
                                _vm.dataInfo.salesman
                                  ? _vm.dataInfo.salesman.name
                                  : "--"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v("客户编号："),
                          ]),
                          _c("span", { staticClass: "weight" }, [
                            _vm._v(_vm._s(_vm.dataInfo.customer_no)),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tabData.length
            ? _c(
                "el-tabs",
                {
                  attrs: {
                    "tab-position": _vm.tabPosition,
                    type: "border-card",
                  },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.tabIndex,
                    callback: function ($$v) {
                      _vm.tabIndex = $$v
                    },
                    expression: "tabIndex",
                  },
                },
                _vm._l(_vm.tabData, function (item) {
                  return _c("el-tab-pane", {
                    key: item.value,
                    attrs: { label: item.label, name: item.value },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "contract-body table-box" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber == 1,
                    expression: "tabNumber == 1",
                  },
                ],
                staticClass: "contract-info",
              },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "invoice-body",
                    attrs: { "label-width": "auto" },
                  },
                  _vm._l(_vm.dataInfo.list, function (item, index) {
                    return _c("div", { key: index }, [
                      _c("div", { staticClass: "from-item-title mb15" }, [
                        _c("span", [_vm._v(_vm._s(item.title))]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-box" },
                        _vm._l(item.data, function (value, key) {
                          return _c(
                            "div",
                            {
                              key: key,
                              staticClass: "form-item",
                              class:
                                value.type !== "file" &&
                                value.type !== "image" &&
                                value.type !== "oaWangeditor"
                                  ? ""
                                  : "oneline",
                            },
                            [
                              value.key == "customer_status"
                                ? _c("el-form-item", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v(_vm._s(value.key_name) + ":")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(value.value[0] || "-")),
                                    ]),
                                  ])
                                : value.type == "file" || value.type == "images"
                                ? _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v(_vm._s(value.key_name) + ":")]
                                      ),
                                      _vm._v(" "),
                                      value.files && value.files.length > 0
                                        ? _c("upload-file", {
                                            staticClass: "upload-file",
                                            attrs: {
                                              "file-list": value.files,
                                              fileWidth: "300px",
                                              url: "/system/attach/upload",
                                            },
                                          })
                                        : _c("span", [_vm._v("--")]),
                                    ],
                                    1
                                  )
                                : value.type == "oaWangeditor"
                                ? _c("el-form-item", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v(_vm._s(value.key_name) + ":")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "content",
                                      domProps: {
                                        innerHTML: _vm._s(value.value),
                                      },
                                    }),
                                  ])
                                : _c("el-form-item", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v(_vm._s(value.key_name) + ":")]
                                    ),
                                    _vm._v(" "),
                                    _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getValue(value.value)
                                        ),
                                      },
                                    }),
                                  ]),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  }),
                  0
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 2,
                    expression: "tabNumber === 2",
                  },
                ],
                staticClass: "contract-record",
              },
              [
                _c("record", {
                  ref: "record",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 8,
                    expression: "tabNumber === 8",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("liaison", {
                  ref: "liaison",
                  attrs: {
                    customInfo: _vm.customInfo,
                    custom_type: _vm.custom_type,
                    "form-info": _vm.formData,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 3,
                    expression: "tabNumber === 3",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("contract", {
                  ref: "contract",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 4,
                    expression: "tabNumber === 4",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("contract-record-all", {
                  ref: "contractRecord",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 5,
                    expression: "tabNumber === 5",
                  },
                ],
                staticClass: "contract-remind",
              },
              [
                _c("contract-remind", {
                  ref: "contractRemind",
                  attrs: { "form-info": _vm.formData, type: 1 },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 6,
                    expression: "tabNumber === 6",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("contract-invoice", {
                  ref: "contractInvoice",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 7,
                    expression: "tabNumber === 7",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("file", {
                  ref: "file",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 9,
                    expression: "tabNumber === 9",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("dynamic-record", {
                  ref: "dynamicRecord",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 10,
                    expression: "tabNumber === 10",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("detection-data", {
                  ref: "detectionData",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("remind-dialog", {
        ref: "remindDialog",
        attrs: { config: _vm.remindConfig },
        on: { change: _vm.change },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }